module.exports = __webpack_public_path__ + "img/icon_logo.02483fec.png";